export type Language = 'nb' | 'en';
export type LanguageName = 'Norwegian' | 'English';
export const LANGUAGE_KEY = 'LANGUAGE';
